import { XIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { v4 as uuid } from "uuid";

export default function AddNewGroup({close, type, editData}) {

  const [data, setData] = useState({
    ledger_group_uuid: type==='New'? '': editData.ledger_group_uuid,
    ledger_group_title: type==='New'? '': editData.ledger_group_title,
    outlet_uuid: type==='New'? '': editData.outlet_uuid,
  });

  const handleSave = async (e)=>{
    e.preventDefault();
    const json = {
      ledger_group_uuid: uuid(),
      ledger_group_title: data.ledger_group_title,
      outlet_uuid: localStorage.getItem("outlet_uuid"),
    }
    const url = `https://api.myfooddo.com/acLedgerGroup/CreateLedgerGroup`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("CreateLedgerGroup...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }

  const handleEdit = async (e)=>{
    e.preventDefault();
    const json = {
      ledger_group_uuid: data.ledger_group_uuid,
      ledger_group_title: data.ledger_group_title,
      outlet_uuid: data.outlet_uuid,
    }
    const url = `https://api.myfooddo.com/acLedgerGroup/EditLedgerGroup`;
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("EditLedgerGroup...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }
  
  return (
    <div className='newCategory' draggable={false}>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Group</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <form className='newCatContainer2' action='' onSubmit={type==='New'? handleSave : handleEdit}>
          <div className='cat-inp'>
            <label htmlFor='ledgerGroupTitle'>Group Name</label>
            <input
              value={data.ledger_group_title}
              onChange={e =>setData({
                ...data,
                ledger_group_title: e.target.value,
              })}
              maxLength={40}
              type='text'
              required
              id='ledgerGroupTitle'
            />
          </div>
          {type === "New" ? (
            <button>Save</button>
          ) : (
            <button>Update</button>
          )}
        </form>
      </div>
    </div>
  );
}
